<template>
  <div class="content">
    <div class="main">
      <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item @click.native="goback">返回</el-breadcrumb-item>
          <el-breadcrumb-item>主题活动</el-breadcrumb-item>
          <el-breadcrumb-item>{{text}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <el-row :gutter="20">
        <el-col :span="18">
          <div class="video_left">
            <div class="viefo_main">
              <video
                ref="video"
                class="videoPlayer"
                :src="video_url"
                controls="controls"
                controlslist="nodownload"
              >您的浏览器不支持 video 标签。</video>
            </div>
            <div class="bottom_tabs">
              <el-tabs v-model="activeName">
                <el-tab-pane label="活动介绍" name="first" v-if="curriculumInfo.main_content">
                  <mavon-editor
                    v-model="curriculumInfo.main_content"
                    defaultOpen="preview"
                    :boxShadow="false"
                    :editable="false"
                    :subfield="false"
                    :toolbarsFlag="false"
                  ></mavon-editor>
                </el-tab-pane>
                <el-tab-pane label="老师提问" name="second" v-if="curriculumInfo.tch_question_content">
                  <mavon-editor
                    v-model="curriculumInfo.tch_question_content"
                    defaultOpen="preview"
                    :boxShadow="false"
                    :editable="false"
                    :subfield="false"
                    :toolbarsFlag="false"
                  ></mavon-editor>
                </el-tab-pane>
                <el-tab-pane label="资料下载" name="third" v-if="curriculumInfo.download_content">
                  <mavon-editor
                    v-model="curriculumInfo.download_content"
                    defaultOpen="preview"
                    :boxShadow="false"
                    :editable="false"
                    :subfield="false"
                    :toolbarsFlag="false"
                  ></mavon-editor>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="video_right">
            <div class="video" v-show="false">
              <span class="title_test">活动引导</span>
              <div class="video_content">
                <video
                  ref="video"
                  class="video_player"
                  src="video_url"
                  controls="controls"
                  controlslist="nodownload"
                >您的浏览器不支持 video 标签。</video>
              </div>
            </div>

            <div class="tool">
              <div class="title_test">直播工具</div>
              <div class="donwnlond">
                <el-button plain size="mini" @click="tenxun">腾讯会议下载</el-button>
                <el-button plain size="mini" style="margin-left:20px;" @click="ding">钉钉直播下载</el-button>
              </div>
            </div>
            <span class="title_test" style="display:block; margin-top:20px">联系我们</span>
            <div class="image">
              <img :src="this.img" style="width:100%;height:100%" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true // 预览
      },
      activeName: "first",
      curriculumInfo: {},

      img: "",
      video_url: ""
    };
  },
  created() {
    console.log(JSON.parse(this.$route.query.curriculumList), "123456789");

    // this.text = JSON.parse(this.$route.query.curriculumList.title)
  },
  mounted() {
    this.getInfo();
  },

  methods: {
    tenxun() {
      window.open(
        "https://meeting.tencent.com/activities/?fromSource=sem81_gwzcw.447781123.4477849.447781162&bd_vid=11177079621011728269"
      );
    },
    ding() {
      window.open(
        "https://page.dingtalk.com/wow/z/dingtalk/default/dddownload-index?from=zebra:offline"
      );
    },
    getInfo() {
      this.curriculumInfo = JSON.parse(this.$route.query.curriculumList);
      this.img = this.curriculumInfo.group_img_url;
      this.video_url = this.curriculumInfo.video_url;
      this.text = this.curriculumInfo.title;
    },
    handleNodeClick(data) {
      console.log(data);
      this.$refs.dataConfigTree.setCurrentKey(data.id);
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  width: 100%;
  // height: 40px;
  background-color: #fff;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  cursor: pointer;
}
.title_left {
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  cursor: pointer;
}
.main {
  width: 100%;
  height: auto;
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
  overflow: hidden;
  border-radius: 5px;
  padding: 20px;
}
.video_right {
  // width: 321px;
  height: auto;
  min-height: 100vh;

  // float: right;
  background-color: #fff;
  padding-left: 10px;
  padding-top: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}
.video_left {
  // width: calc(100% - 341px);
  min-height: 100vh;
  height: auto;
  // padding: 14px;
  // float: left;
  background-color: #fff;
  box-sizing: border-box;
  margin-top: 20px;
}
.newTitle {
  font-weight: bold;
  font-size: 16px;
}
.content_txt1 {
  margin-top: 25px;
  font-size: 16px;
}
.image {
  width: 217px;
  height: 213px;
  border: 1px solid #ccc;
  margin-top: 20px;
}
.title_test {
  font-size: 16px;
  font-weight: bold;
}
.donwnlond {
  width: 350px;
  margin-top: 20px;
}

.tool {
  margin-top: 20px;
}
.video_content {
  .video_player {
    width: 100%;
    border: 2px solid #dee2e9;
    object-fit: fill;
    margin-top: 20px;
  }
}
.viefo_main {
  .videoPlayer {
    width: 100%;
    border: 2px solid #dee2e9;
    object-fit: fill;
    // margin-top: 20px;
  }
}

.video {
  width: 100%;
  margin-top: 7px;
}
.bottom_tabs {
  margin-top: 10px;
}
.video_contenttxt {
  width: 100%;
  height: auto;
  margin-top: 0px;
  border: rgba(247, 239, 227, 1) solid 1px;
  padding-left: 15px;
  box-sizing: border-box;
}
.video_contenttxt h3 {
  margin-top: 15px;
}
</style>

